import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { hasPerm } from './permissions';

// Wrap a route element to enforce a permission. Falls open for legacy sessions
// (no permission list) so nobody is locked out unexpectedly.
const RequirePerm = ({ perm, children }) => {
  const navigate = useNavigate();
  if (!perm || hasPerm(perm)) return children;
  return (
    <Result
      status="403"
      title="No access"
      subTitle="Your role doesn't have permission to view this page."
      extra={<Button type="primary" onClick={() => navigate('/dashboard')}>Go to Dashboard</Button>}
    />
  );
};

export default RequirePerm;
